import { OlModeProps, OlModeTable } from '@repo/toolkit/ol-mode-table-helper'
import { useNavigator } from '@repo/toolkit/use-navigator'
import { Column } from '@repo/ui/data-table'
import { useRef } from 'react'

import { API, constructApiUrl } from '../../../../api/apis.config'
import { Paths } from '../../../../lib/constants/path'
import { Tefl } from '../../../../lib/types/models/tefl/tefl'
import DynamicDataTable, { DynamicTableRef } from '../../../elements/dynamic-table'
import { olNameColumn } from '../common/ol-columns'
import TeflAverageRating from './tefl-average-rating'

type OlTeflTableProps = OlModeProps

const OlTeflTable = (props: OlTeflTableProps) => {
  const { navigateWithEvent } = useNavigator()
  const tableRef = useRef<DynamicTableRef<Tefl>>(null)

  const mode = new OlModeTable(props)

  const endpoint = mode.endpoint({
    ol: (olId) => constructApiUrl(API.tefl.getAllTeflByOlId.url, { olId }),
    global: API.tefl.getAll.url
  })

  const baseColumns: Column<Tefl>[] = [
    {
      enableSorting: true,
      header: 'NOM',
      accessorKey: 'lastName',
      cell: ({ row }) => row.original.lastName.toUpperCase()
    },
    { enableSorting: true, header: 'Prénom', accessorKey: 'firstName' },
    {
      accessorKey: 'activeWorkingYears',
      header: 'Ancienneté (en années)',
      cell: ({ row }) => <div className={'text-center'}>{row.original.activeWorkingYears}</div>
    },
    { accessorKey: 'centerTeflsCount', header: '# de centres enseignés' },
    {
      enableSorting: true,
      accessorKey: 'averageRating',
      header: 'Note moyenne donnée par les jeunes',
      cell: ({ row }) => <TeflAverageRating {...row.original} />
    }
  ]

  const columns = mode.columns(baseColumns, [olNameColumn<Tefl>()])

  const onRowClick = (tefl: Tefl, event?: React.MouseEvent) => {
    navigateWithEvent(
      Paths.OL_TEFL_DETAILS_PAGE.replace(':teflId', tefl.id.toString()).replace(
        ':olId',
        tefl.olId.toString()
      ),
      event
    )
  }

  return (
    <DynamicDataTable<Tefl>
      ref={tableRef}
      title="Tous les TEFL"
      deleteMessage={{ attributeName: 'firstName', name: 'TEFL' }}
      columns={columns}
      allowSearchParam
      selectable
      onRowClick={onRowClick}
      endpoint={endpoint}
      version="FULL"
    />
  )
}

export default OlTeflTable
